module.exports = __webpack_public_path__ + "static/media/03-_DSC9739.57291165.jpg";